import React from "react";
import Filtro from "./Filtro";

const Bitacora = () => {
  return (
    <>
      <Filtro></Filtro>
    </>
  );
}
export default Bitacora;